export const IceSectorL4 = {
  AbsMiscellaneousAbs: 'ABS Miscellaneous ABS',
  Advertising: 'Advertising',
  AerospaceDefense: 'Aerospace/Defense',
  Agency: 'Agency',
  AirTransportation: 'Air Transportation',
  AutoLoans: 'Auto Loans',
  AutoPartsEquipment: 'Auto Parts & Equipment',
  Automakers: 'Automakers',
  Banking: 'Banking',
  Beverage: 'Beverage',
  Brokerage: 'Brokerage',
  BuildingConstruction: 'Building & Construction',
  BuildingMaterials: 'Building Materials',
  CableSatelliteTv: 'Cable & Satellite TV',
  Chemicals: 'Chemicals',
  ConsCommLeaseFinancing: 'Cons/Comm/Lease Financing',
  CvtAdvertising: 'Cvt-Advertising',
  CvtAerospaceDefense: 'Cvt-Aerospace/Defense',
  CvtAirTransportation: 'Cvt-Air Transportation',
  CvtAutoPartsEquipment: 'Cvt-Auto Parts & Equipment',
  CvtAutomakers: 'Cvt-Automakers',
  CvtBanking: 'Cvt-Banking',
  CvtBeverage: 'Cvt-Beverage',
  CvtBrokerage: 'Cvt-Brokerage',
  CvtBuildingConstruction: 'Cvt-Building & Construction',
  CvtCableSatelliteTv: 'Cvt-Cable & Satellite TV',
  CvtChemicals: 'Cvt-Chemicals',
  CvtConsCommLeaseFinancing: 'Cvt-Cons/Comm/Lease Financing',
  CvtDepartmentStores: 'Cvt-Department Stores',
  CvtDiversifiedCapitalGoods: 'Cvt-Diversified Capital Goods',
  CvtElectricDistrTrans: 'Cvt-Electric-Distr/Trans',
  CvtElectricGeneration: 'Cvt-Electric-Generation',
  CvtElectricIntegrated: 'Cvt-Electric-Integrated',
  CvtElectronics: 'Cvt-Electronics',
  CvtEnergyExplorationProduction: 'Cvt-Energy - Exploration & Production',
  CvtEnvironmental: 'Cvt-Environmental',
  CvtFoodDrugRetailers: 'Cvt-Food & Drug Retailers',
  CvtFoodWholesale: 'Cvt-Food - Wholesale',
  CvtForestryPaper: 'Cvt-Forestry/Paper',
  CvtGaming: 'Cvt-Gaming',
  CvtGasDistribution: 'Cvt-Gas Distribution',
  CvtHealthFacilities: 'Cvt-Health Facilities',
  CvtHealthServices: 'Cvt-Health Services',
  CvtHotels: 'Cvt-Hotels',
  CvtIntegratedEnergy: 'Cvt-Integrated Energy',
  CvtInvestmentsMiscFinancialServices:
    'Cvt-Investments & Misc Financial Services',
  CvtMachinery: 'Cvt-Machinery',
  CvtManagedCare: 'Cvt-Managed Care',
  CvtMediaDiversified: 'Cvt-Media - Diversified',
  CvtMediaContent: 'Cvt-Media Content',
  CvtMedicalProducts: 'Cvt-Medical Products',
  CvtMetalsMiningExcludingSteel: 'Cvt-Metals/Mining Excluding Steel',
  CvtMultiLineInsurance: 'Cvt-Multi-Line Insurance',
  CvtNonElectricUtilities: 'Cvt-Non-Electric Utilities',
  CvtOilFieldEquipmentServices: 'Cvt-Oil Field Equipment & Services',
  CvtOilRefiningMarketing: 'Cvt-Oil Refining & Marketing',
  CvtPC: 'Cvt-P&C',
  CvtPersonalHouseholdProducts: 'Cvt-Personal & Household Products',
  CvtPharmaceuticals: 'Cvt-Pharmaceuticals',
  CvtPrintingPublishing: 'Cvt-Printing & Publishing',
  CvtReits: 'Cvt-REITs',
  CvtRealEstateDevMgt: 'Cvt-RealEstate Dev & Mgt',
  CvtRecreationTravel: 'Cvt-Recreation & Travel',
  CvtRestaurants: 'Cvt-Restaurants',
  CvtSoftwareServices: 'Cvt-Software/Services',
  CvtSpecialtyRetail: 'Cvt-Specialty Retail',
  CvtSteelProducersProducts: 'Cvt-Steel Producers/Products',
  CvtSupportServices: 'Cvt-Support-Services',
  CvtTechHardwareEquipment: 'Cvt-Tech Hardware & Equipment',
  CvtTelecomSatellite: 'Cvt-Telecom - Satellite',
  CvtTelecomWireless: 'Cvt-Telecom - Wireless',
  CvtTelecomWirelineIntegratedServices:
    'Cvt-Telecom - Wireline Integrated & Services',
  CvtTheatersEntertainment: 'Cvt-Theaters & Entertainment',
  CvtTobacco: 'Cvt-Tobacco',
  CvtTransportInfrastructureServices: 'Cvt-Transport Infrastructure/Services',
  CvtTruckingDelivery: 'Cvt-Trucking & Delivery',
  DepartmentStores: 'Department Stores',
  DiscountStores: 'Discount Stores',
  DiversifiedCapitalGoods: 'Diversified Capital Goods',
  Etm: 'ETM ',
  ElectricDistrTrans: 'Electric-Distr/Trans',
  ElectricGeneration: 'Electric-Generation',
  ElectricIntegrated: 'Electric-Integrated',
  Electronics: 'Electronics',
  EnergyExplorationProduction: 'Energy - Exploration & Production',
  Environmental: 'Environmental',
  FoodDrugRetailers: 'Food & Drug Retailers',
  FoodWholesale: 'Food - Wholesale',
  ForeignSovereign: 'Foreign Sovereign',
  ForestryPaper: 'Forestry/Paper',
  GoLocal: 'GO - Local ',
  GoState: 'GO - State ',
  Gaming: 'Gaming',
  GasDistribution: 'Gas Distribution',
  GovernmentGuaranteed: 'Government Guaranteed',
  HealthFacilities: 'Health Facilities',
  HealthServices: 'Health Services',
  Hotels: 'Hotels',
  HousingAssociation: 'Housing Association',
  InsuranceBrokerage: 'Insurance Brokerage',
  IntegratedEnergy: 'Integrated Energy',
  InvestmentsMiscFinancialServices: 'Investments & Misc Financial Services',
  LifeInsurance: 'Life Insurance',
  LocalAuthority: 'Local-Authority',
  Machinery: 'Machinery',
  ManagedCare: 'Managed Care',
  MediaDiversified: 'Media - Diversified',
  MediaContent: 'Media Content',
  MedicalProducts: 'Medical Products',
  MetalsMiningExcludingSteel: 'Metals/Mining Excluding Steel',
  MonolineInsurance: 'Monoline Insurance',
  MortgageCoveredBonds: 'Mortgage Covered Bonds',
  MultiLineInsurance: 'Multi-Line Insurance',
  NonElectricUtilities: 'Non-Electric Utilities',
  OilFieldEquipmentServices: 'Oil Field Equipment & Services',
  OilRefiningMarketing: 'Oil Refining & Marketing',
  OtherCoveredBonds: 'Other Covered Bonds',
  PC: 'P&C',
  Packaging: 'Packaging',
  PersonalHouseholdProducts: 'Personal & Household Products',
  PfdAutoLoans: 'Pfd-Auto Loans',
  PfdBanking: 'Pfd-Banking',
  PfdBrokerage: 'Pfd-Brokerage',
  PfdConsCommLeaseFinancing: 'Pfd-Cons/Comm/Lease Financing',
  PfdElectricDistrTrans: 'Pfd-Electric-Distr/Trans',
  PfdElectricGeneration: 'Pfd-Electric-Generation',
  PfdElectricIntegrated: 'Pfd-Electric-Integrated',
  PfdFoodWholesale: 'Pfd-Food - Wholesale',
  PfdGasDistribution: 'Pfd-Gas Distribution',
  PfdHealthFacilities: 'Pfd-Health Facilities',
  PfdInvestmentsMiscFinancialServices:
    'Pfd-Investments & Misc Financial Services',
  PfdLifeInsurance: 'Pfd-Life Insurance',
  PfdOilRefiningMarketing: 'Pfd-Oil Refining & Marketing',
  PfdPrintingPublishing: 'Pfd-Printing & Publishing',
  PfdReits: 'Pfd-REITs',
  PfdSoftwareServices: 'Pfd-Software/Services',
  Pharmaceuticals: 'Pharmaceuticals',
  PreRefunded: 'Pre-Refunded ',
  PrintingPublishing: 'Printing & Publishing',
  Reits: 'REITs',
  Rail: 'Rail',
  RealEstateDevMgt: 'RealEstate Dev & Mgt',
  RecreationTravel: 'Recreation & Travel',
  Reinsurance: 'Reinsurance',
  Restaurants: 'Restaurants',
  RevenueAirport: 'Revenue - Airport ',
  RevenueEducation: 'Revenue - Education ',
  RevenueHealth: 'Revenue - Health ',
  RevenueHospitals: 'Revenue - Hospitals ',
  RevenueIndustrialDevelopmentRevenue:
    'Revenue - Industrial Development Revenue ',
  RevenueLeasingCopsAppropriations: 'Revenue - Leasing COPS & Appropriations ',
  RevenueMisc: 'Revenue - Misc ',
  RevenueMultiFamilyHousing: 'Revenue - Multi-Family Housing ',
  RevenuePollutionControl: 'Revenue - Pollution Control ',
  RevenuePower: 'Revenue - Power ',
  RevenueSingleFamilyHousing: 'Revenue - Single Family Housing ',
  RevenueTax: 'Revenue - Tax ',
  RevenueTobacco: 'Revenue - Tobacco ',
  RevenueTollTurnpike: 'Revenue - Toll & Turnpike ',
  RevenueTransportation: 'Revenue - Transportation ',
  RevenueUtilitiesOther: 'Revenue - Utilities - Other ',
  RevenueWaterSewer: 'Revenue - Water & Sewer ',
  SoftwareServices: 'Software/Services',
  Sovereign: 'Sovereign',
  SpecialtyRetail: 'Specialty Retail',
  SteelProducersProducts: 'Steel Producers/Products',
  SupportServices: 'Support-Services',
  Supranational: 'Supranational',
  TaxableEtm: 'Taxable ETM ',
  TaxableGoLocal: 'Taxable GO - Local ',
  TaxableGoState: 'Taxable GO - State ',
  TaxableRevenueAirport: 'Taxable Revenue - Airport ',
  TaxableRevenueEducation: 'Taxable Revenue - Education ',
  TaxableRevenueHealth: 'Taxable Revenue - Health ',
  TaxableRevenueHospitals: 'Taxable Revenue - Hospitals ',
  TaxableRevenueIndustrialDevelopmentRevenue:
    'Taxable Revenue - Industrial Development Revenue ',
  TaxableRevenueLeasingCopsAppropriations:
    'Taxable Revenue - Leasing COPS & Appropriations ',
  TaxableRevenueMisc: 'Taxable Revenue - Misc ',
  TaxableRevenueMultiFamilyHousing: 'Taxable Revenue - Multi-Family Housing ',
  TaxableRevenuePollutionControl: 'Taxable Revenue - Pollution Control ',
  TaxableRevenuePower: 'Taxable Revenue - Power ',
  TaxableRevenueSingleFamilyHousing: 'Taxable Revenue - Single Family Housing ',
  TaxableRevenueTax: 'Taxable Revenue - Tax ',
  TaxableRevenueTobacco: 'Taxable Revenue - Tobacco ',
  TaxableRevenueTollTurnpike: 'Taxable Revenue - Toll & Turnpike ',
  TaxableRevenueTransportation: 'Taxable Revenue - Transportation ',
  TaxableRevenueUtilitiesOther: 'Taxable Revenue - Utilities - Other ',
  TaxableRevenueWaterSewer: 'Taxable Revenue - Water & Sewer ',
  TechHardwareEquipment: 'Tech Hardware & Equipment',
  TelecomSatellite: 'Telecom - Satellite',
  TelecomWireless: 'Telecom - Wireless',
  TelecomWirelineIntegratedServices: 'Telecom - Wireline Integrated & Services',
  TheatersEntertainment: 'Theaters & Entertainment',
  Tobacco: 'Tobacco',
  TransportInfrastructureServices: 'Transport Infrastructure/Services',
  TruckingDelivery: 'Trucking & Delivery',
} as const

export type IceSectorL4 = (typeof IceSectorL4)[keyof typeof IceSectorL4]
